import { getCarRentalDaysCount, calculateCarRentalPrice } from '../products/helpers';
import { getNetFromGross } from '../../common/financial';

export function getValidFromDate() {
  const now = new Date();
  let result = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() + 1);
  if (result.getDay() === 0) {
    result = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 9);
  }
  if (result.getDay() === 6) {
    result = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 2, 9);
  }
  return result;
}

export function getValidEndDate(fromDate) {
  let result = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate() + 1, 9);
  if (result.getDay() === 0) {
    result = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate() + 2, 9);
  }
  if (result.getDay() === 6) {
    result = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate() + 3, 9);
  }
  return result;
}

export function getCarRentItems(item, dateFrom, dateTo, messages) {
  const daysCount = getCarRentalDaysCount(dateFrom, dateTo);
  const invoiceValues = calculateCarRentalPrice(item, daysCount, dateFrom, dateTo);

  const res = [];
  if (invoiceValues.weekdayCount) {
    res.push({
      ...item,
      code: 'RENTAL_WEEKDAY',
      name: messages.car_rental_weekday,
      description: item.name,
      quantity: invoiceValues.weekdayCount,
      grossPrice: invoiceValues.weekdayPrice,
      price: invoiceValues.weekdayPrice,
      netPrice: getNetFromGross(invoiceValues.weekdayPrice, item.pricing.vat_rate),
      vatRate: item.pricing.vat_rate,
    });
  }

  if (invoiceValues.weekendCount) {
    res.push({
      ...item,
      code: 'RENTAL_WEEKEND',
      name: messages.car_rental_weekend,
      description: item.name,
      quantity: invoiceValues.weekendCount,
      grossPrice: invoiceValues.weekendPrice,
      price: invoiceValues.weekendPrice,
      netPrice: getNetFromGross(invoiceValues.weekendPrice, item.pricing.vat_rate),
      vatRate: item.pricing.vat_rate,
    });
  }

  if (invoiceValues.weekCount) {
    res.push({
      ...item,
      code: 'RENTAL_WEEK',
      name: messages.car_rental_week,
      description: item.name,
      quantity: invoiceValues.weekCount,
      grossPrice: invoiceValues.weekPrice,
      price: invoiceValues.weekPrice,
      netPrice: getNetFromGross(invoiceValues.weekPrice, item.pricing.vat_rate),
      vatRate: item.pricing.vat_rate,
    });
  }

  if (invoiceValues.monthCount) {
    res.push({
      ...item,
      code: 'RENTAL_MONTH',
      name: messages.car_rental_month,
      description: item.name,
      quantity: invoiceValues.monthCount,
      grossPrice: invoiceValues.monthPrice,
      price: invoiceValues.monthPrice,
      netPrice: getNetFromGross(invoiceValues.monthPrice, item.pricing.vat_rate),
      vatRate: item.pricing.vat_rate,
    });
  }

  return res;
}
